import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

/**
 * Shared hook for Division 7 modal URL state persistence.
 * Keeps preview/edit modal state in URL query params so it survives refresh & back/forward.
 *
 * @param {'ti'|'ab'|'wb'} itemKey — which D7 section owns this instance
 */
export function useDivision7ModalState(itemKey) {
  const [searchParams, setSearchParams] = useSearchParams();

  const urlModal = searchParams.get('d7Modal');
  const urlPid = searchParams.get('d7Pid');
  const urlItem = searchParams.get('d7Item');

  const isMatch = urlItem === itemKey && !!urlModal && !!urlPid;

  const openModal = useCallback((type, pid) => {
    setSearchParams(prev => {
      const next = new URLSearchParams(prev);
      next.set('d7Modal', type);
      next.set('d7Pid', pid);
      next.set('d7Item', itemKey);
      return next;
    });
  }, [itemKey, setSearchParams]);

  const closeModal = useCallback(() => {
    setSearchParams(prev => {
      const next = new URLSearchParams(prev);
      next.delete('d7Modal');
      next.delete('d7Pid');
      next.delete('d7Item');
      return next;
    }, { replace: true });
  }, [setSearchParams]);

  return {
    urlModal: isMatch ? urlModal : null,
    urlProductId: isMatch ? urlPid : null,
    openModal,
    closeModal,
  };
}
